import React from 'react';
import ChatWindow from '../chatWindow/ChatWindow';
import './home.css';

function Home() {
  return (
    <>
      {/* { thing } */}
      {/* { displayThing } */}
      <div>
        <ChatWindow />
      </div>
    </>
  );
}

export default Home;
